export enum KnowledgeBaseTypeEnum {
    PDF = "pdf",
    WEBSITE = "website",
    COMBINED = "combined",
}